const Pagination = ({
    currentPage,
    totalPages,
    onPageChange
}) => {

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        onPageChange(page);
    };

    const getPages = () => {
        const pages = [];

        if (totalPages <= 4) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(
                    1,
                    '...',
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    '...',
                    totalPages
                );
            }
        }

        return pages;
    };

    return (
        <div className="flex justify-end items-center gap-[10px] flex-wrap">

            {/* Prev */}
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-[16px] py-[8px] rounded-[8px] text-white disabled:opacity-40"
                style={{ background: 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)' }}
            >
                Prev
            </button>

            {/* Pages */}
            {getPages().map((page, idx) =>
                typeof page === "string" ? (
                    <span key={idx} className="px-[10px] text-[#174A84]">
                        ...
                    </span>
                ) : (
                    <button
                        key={idx}
                        onClick={() => handlePageChange(page)}
                        disabled={page === currentPage}
                        className="px-[14px] py-[8px] rounded-[8px] disabled:opacity-40"
                        style={{
                            background: page === currentPage
                                ? 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)'
                                : '#fff',
                            color: page === currentPage ? '#fff' : '#174A84',
                            border: '1px solid #8773DC'
                        }}
                    >
                        {page}
                    </button>
                )
            )}

            {/* Next */}
            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-[16px] py-[8px] rounded-[8px] text-white disabled:opacity-40"
                style={{ background: 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)' }}
            >
                Next
            </button>
        </div>
    );
};

export default Pagination;